import React from 'react';
import Table from 'react-bootstrap/Table';

import EnrollmentRequestsTableRow from '../components/EnrollmentRequestsTableRow';

class EnrollmentRequestsTable extends React.Component {
  render() {

    const { data, getData, showModal } = this.props;

    return (
      <Table hover>
        <thead>
          <tr>
            <th>VIN</th>
            <th>Zulassungsdatum</th>
            <th>Herkunftsland</th>
            <th>Status</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        {data.requests && (
          <tbody>
            {data.requests.map((request, index) => (
              <EnrollmentRequestsTableRow
                  key={index}
                  request={request}
                  getData={getData}
                  showModal={showModal}
              />
            ))}
          </tbody>
        )}
      </Table>
    );
  }
}

export default EnrollmentRequestsTable;
